<script setup lang="ts">
import { computed } from "vue";
import Tooltip from "./Tooltip.vue";

interface Props {
  disabled?: boolean;
  tooltipPosition?: "top" | "bottom" | "left" | "right" | "bottom-right" | "top-right" | "top-mid";
  tooltipMessage?: string;
  tooltipIcon?: string;
  tooltipWidth?: string;
  customTooltip?: boolean;
  enabledTooltipMessage?: string;
  enabledTooltipIcon?: string;
  noIcon?: boolean;
  minified?: boolean;
  forcePositionTop?: number;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  tooltipPosition: "bottom-right",
  tooltipMessage: "Cette action n'est pas disponible",
  tooltipIcon: "/icons/emojis/eyes.svg",
  tooltipWidth: "300px",
  customTooltip: false,
  enabledTooltipMessage: undefined,
  enabledTooltipIcon: undefined,
  noIcon: false,
  minified: false,
  forcePositionTop: undefined,
});

const showTooltip = computed(() => props.disabled || props.enabledTooltipMessage);
const currentIcon = computed(() => (props.disabled ? props.tooltipIcon : props.enabledTooltipIcon));
const currentMessage = computed(() => (props.disabled ? props.tooltipMessage : props.enabledTooltipMessage));
const isMinified = computed(() => !props.disabled && props.minified);
</script>

<template>
  <Tooltip
    v-if="showTooltip"
    :position="tooltipPosition"
    append-to-body
    :minified="isMinified"
    :force-position-top="forcePositionTop"
  >
    <template #img>
      <slot name="button" :disabled="disabled" />
    </template>
    <template #content>
      <!-- Custom tooltip content -->
      <slot v-if="customTooltip" name="tooltip-content" />

      <!-- Default tooltip content -->
      <div
        v-else
        class="flex gap-[8px] items-center"
        :class="{ 'w-fit whitespace-nowrap': !disabled }"
        :style="disabled ? { width: tooltipWidth } : undefined"
      >
        <img v-if="currentIcon && !noIcon" :src="currentIcon" alt="" :style="{ height: '16px', width: '16px' }" />
        <span :class="disabled ? 'body_regular' : 'meta'">{{ currentMessage }}</span>
      </div>
    </template>
  </Tooltip>

  <!-- Display without tooltip -->
  <slot v-else name="button" :disabled="disabled" />
</template>
